import { render, staticRenderFns } from "./BuyNowPayLaterTitle.vue?vue&type=template&id=40a2b744&scoped=true"
import script from "./BuyNowPayLaterTitle.vue?vue&type=script&lang=js"
export * from "./BuyNowPayLaterTitle.vue?vue&type=script&lang=js"
import style0 from "./BuyNowPayLaterTitle.vue?vue&type=style&index=0&id=40a2b744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a2b744",
  null
  
)

export default component.exports